import React from 'react'

const Comment = ({ author, avatar, content, datetime, actions, children }) => (
    <div className="ant-comment" style={{ display: 'flex', padding: '16px 0' }}>
        {avatar && (
            <div className="ant-comment-avatar" style={{ marginRight: 12, flexShrink: 0 }}>
                {avatar}
            </div>
        )}
        <div className="ant-comment-content" style={{ flex: 1, minWidth: 0, wordWrap: 'break-word' }}>
            <div className="ant-comment-content-author" style={{ marginBottom: 4 }}>
                {author && (
                    <span className="ant-comment-content-author-name"
                        style={{ marginRight: 8, color: 'rgba(0,0,0,0.45)', fontSize: 14 }}>
                        {author}
                    </span>
                )}
                {datetime && (
                    <span className="ant-comment-content-author-time"
                        style={{ color: 'rgba(0,0,0,0.45)', fontSize: 12 }}>
                        {datetime}
                    </span>
                )}
            </div>
            <div className="ant-comment-content-detail">{content}</div>
            {actions && actions.length > 0 && (
                <ul className="ant-comment-actions"
                    style={{ marginTop: 8, paddingLeft: 0, listStyle: 'none' }}>
                    {actions.map((a, i) => (
                        <li key={i} style={{ display: 'inline-block', marginRight: 12 }}>{a}</li>
                    ))}
                </ul>
            )}
            {children}
        </div>
    </div>
)

export default Comment
